export const LOADING_LOGOUT = "LOADING_LOGOUT";

export const SWITCH_VIEW = "SWITCH_VIEW";
